'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetForm = exports.populateForm = exports.initialiseForm = undefined;
var _constants = require('../constants');

// Load default state to formId key
var initialiseForm = exports.initialiseForm = function initialiseForm(formId, form) {
  return {
    type: _constants.actionTypes.INITIALISE_FORM,
    formId: formId
  };
};

// Autofill form state (default state is spread first)
var populateForm = exports.populateForm = function populateForm(formId, form) {
  var snapshot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: _constants.actionTypes.POPULATE_FORM,
    formId: formId,
    form: form,
    snapshot: snapshot
  };
};

// Reset whole form to default
var resetForm = exports.resetForm = function resetForm(formId) {
  var snapshot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: _constants.actionTypes.RESET_FORM,
    formId: formId,
    snapshot: snapshot
  };
};